import { styled } from '@mui/material';

import { Icon as AppIcon } from '../Icon';

export const Avatar = styled('div', {
  shouldForwardProp: (prop) => prop !== 'size',
})(({ theme, size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: size === 'lg' ? '78px' : size === 'sm' ? '36px' : '68px',
  height: size === 'lg' ? '78px' : size === 'sm' ? '36px' : '68px',
  borderRadius: '100%',
  overflow: 'hidden',
  color: theme.palette.color.fg.primary,
  backgroundColor: theme.palette.color.avatar,
  transition:
    'color var(--transition-ease-default), background-color var(--transition-ease-default)',

  [theme.breakpoints.down('2xl')]: size !== 'sm' && {
    width: size === 'lg' ? '68px' : '58px',
    height: size === 'lg' ? '68px' : '58px',
  },
  [theme.breakpoints.down('md')]: size !== 'sm' && {
    width: '58px',
    height: '58px',
  },
}));

export const Icon = styled(AppIcon, {
  shouldForwardProp: (prop) => prop !== 'size',
})(({ theme, size }) => ({
  width: size === 'lg' ? '42px' : size === 'sm' ? '20px' : '32px',
  height: size === 'lg' ? '42px' : size === 'sm' ? '20px' : '32px',

  [theme.breakpoints.down('2xl')]: size !== 'sm' && {
    width: '32px',
    height: '32px',
  },
}));

export const Img = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
}));
